import React from "react";

import { Field } from "redux-form";
import { connect } from "react-redux";

class FullTimeInput extends React.Component {
  renderFullInput = (formProps) => {
    return (
      <div className="header__filter--input--full">
        <input
          autocomplete="off"
          {...formProps.input}
          id="fulltime"
          type="checkbox"
          className={`checkbox--hidden checkbox--hidden--desktop`}
          value={false}
        />
        <label
          htmlFor="fulltime"
          className={`checkbox checkbox--desktop ${
            formProps.darkMode ? "dark--2" : ""
          }`}
        ></label>
        <label
          className={` ${formProps.darkMode ? "white" : ""}`}
          htmlFor={`fulltime`}
        >
          {formProps.label}
        </label>
        <button className="btn btn--form" type="submit">
          Search
        </button>
      </div>
    );
  };
  render() {
    return (
      <React.Fragment>
        <Field
          name="fulltime"
          component={this.renderFullInput}
          label="Full Time"
          type="checkbox"
          darkMode={this.props.darkMode}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    jobs: state.jobs,
    formValues: state.form,
    isLoading: state.loader.isLoading,
    darkMode: state.darkMode,
  };
};

export default connect(mapStateToProps)(FullTimeInput);
